(() => {
  const galleries = document.querySelectorAll('[data-project-gallery]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  galleries.forEach((gallery) => {
    const tabs = [...gallery.querySelectorAll('[data-gallery-tab]')];
    const panels = [...gallery.querySelectorAll('[data-gallery-panel]')];
    const toggle = gallery.querySelector('[data-gallery-toggle]');
    const toggleLabel = gallery.querySelector('[data-gallery-toggle-label]');

    const measureViewport = (viewport) => {
      const image = viewport.querySelector('[data-gallery-image]');
      if (!image?.naturalWidth || !viewport.clientWidth) return;

      const renderedHeight = image.naturalHeight * (viewport.clientWidth / image.naturalWidth);
      const distance = Math.max(0, renderedHeight - viewport.clientHeight);
      const duration = Math.max(34, Math.min(112, distance / 44));

      viewport.style.setProperty('--gallery-distance', `${-distance}px`);
      viewport.style.setProperty('--gallery-duration', `${duration}s`);
      viewport.classList.toggle('is-scrollable', distance > 18 && !reducedMotion.matches);
    };

    const measurePanel = (panel) => {
      panel.querySelectorAll('[data-gallery-viewport]').forEach((viewport) => {
        const image = viewport.querySelector('[data-gallery-image]');
        if (image?.complete) measureViewport(viewport);
        else image?.addEventListener('load', () => measureViewport(viewport), { once: true });
      });
    };

    const activate = (index, moveFocus = false) => {
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus();
      });

      panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      const panel = panels[index];
      if (!panel) return;
      requestAnimationFrame(() => {
        measurePanel(panel);
        panel.querySelectorAll('[data-gallery-image]').forEach((image) => {
          image.style.animation = 'none';
          void image.offsetWidth;
          image.style.animation = '';
        });
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activate(next, true);
      });
    });

    toggle?.addEventListener('click', () => {
      const paused = gallery.classList.toggle('is-paused');
      toggle.setAttribute('aria-pressed', String(paused));
      if (toggleLabel) toggleLabel.textContent = paused ? 'Resume auto-scroll' : 'Pause auto-scroll';
    });

    const resizeObserver = new ResizeObserver(() => {
      const activePanel = panels.find((panel) => !panel.hidden);
      if (activePanel) measurePanel(activePanel);
    });
    resizeObserver.observe(gallery);

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        gallery.classList.toggle('is-offscreen', !entry.isIntersecting);
      }, { rootMargin: '160px 0px' });
      visibilityObserver.observe(gallery);
    }

    reducedMotion.addEventListener?.('change', () => {
      panels.forEach(measurePanel);
    });

    activate(0);
  });

  const storefrontPreviews = document.querySelectorAll('[data-storefront-preview]');

  storefrontPreviews.forEach((viewport) => {
    const image = viewport.querySelector('[data-storefront-image]');
    if (!image) return;
    viewport.classList.add('is-offscreen');

    const measure = () => {
      if (!image.naturalWidth || !viewport.clientWidth) return;

      const renderedHeight = image.naturalHeight * (viewport.clientWidth / image.naturalWidth);
      const distance = Math.max(0, renderedHeight - viewport.clientHeight);
      const duration = Math.max(48, Math.min(150, distance / 32));

      viewport.style.setProperty('--storefront-distance', `${-distance}px`);
      viewport.style.setProperty('--storefront-duration', `${duration}s`);
      viewport.classList.toggle('is-scrollable', distance > 18 && !reducedMotion.matches);
    };

    if (image.complete) measure();
    else image.addEventListener('load', measure, { once: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', measure, { passive: true });
    }

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        viewport.classList.toggle('is-offscreen', !entry.isIntersecting);
      }, { rootMargin: '160px 0px' });
      visibilityObserver.observe(viewport);
    }

    reducedMotion.addEventListener?.('change', measure);
  });
})();
